import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Trophy, Star } from "lucide-react";

// Listens for window "cehnura:celebrate" events {type:'level'|'badge', label}
export function CelebrationOverlay() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setItem(e.detail || { type: "level", label: "" });
      setTimeout(() => setItem(null), 2600);
    };
    window.addEventListener("cehnura:celebrate", handler);
    return () => window.removeEventListener("cehnura:celebrate", handler);
  }, []);

  const isBadge = item?.type === "badge";
  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 backdrop-blur-md pointer-events-none"
          data-testid="celebration-overlay">
          <motion.div
            initial={{ scale: 0.5, y: 40, rotate: -8 }}
            animate={{ scale: 1, y: 0, rotate: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 16 }}
            className="text-center">
            <div className="relative mx-auto w-28 h-28 rounded-3xl gold-gradient flex items-center justify-center glow-gold">
              {isBadge ? <Trophy className="w-14 h-14 text-black" /> : <Star className="w-14 h-14 text-black" fill="black" />}
              {[...Array(8)].map((_, i) => (
                <motion.span key={i}
                  className="absolute w-2 h-2 rounded-full bg-amber-400"
                  initial={{ x: 0, y: 0, opacity: 1 }}
                  animate={{ x: Math.cos((i / 8) * Math.PI * 2) * 90, y: Math.sin((i / 8) * Math.PI * 2) * 90, opacity: 0 }}
                  transition={{ duration: 1, delay: 0.1 }} />
              ))}
            </div>
            <p className="font-display text-3xl font-extrabold mt-5 gold-text">
              {isBadge ? "Nouveau badge !" : "Niveau supérieur !"}
            </p>
            {item.label && <p className="text-zinc-300 mt-1 text-sm">{item.label}</p>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function celebrate(type, label = "") {
  window.dispatchEvent(new CustomEvent("cehnura:celebrate", { detail: { type, label } }));
}
